import React from 'react';
import BaseGrid from 'components/atoms/base-grid';
import SmsCampaignsPageHeader from 'components/organisms/sms-campaigns/page-header';
import SmsCampaignsStats from 'components/organisms/sms-campaigns/campaigns/stats';
import SmsCampaignsTableFilters from 'components/organisms/sms-campaigns/campaigns/table-filters';
import { useSmsCampaignsProgressQueryFilter } from 'infrastructure/hooks/sms-campaigns/use-sms-campaigns-query-filter';
import SmsCampaignsTable from 'components/organisms/sms-campaigns/campaigns/table';
import { useLocation, useParams } from 'react-router-dom';
import { isValidGuid } from 'infrastructure/functions';

import s from './styles.module.scss';

const SmsCampaignPage: React.FC = () => {
  const { campaignGuid } = useParams();
  if (!campaignGuid || !isValidGuid(campaignGuid)) {
    return null;
  }

  const { state } = useLocation();
  const { count, filter, resetFilter, updateFilter } =
    useSmsCampaignsProgressQueryFilter();

  return (
    <BaseGrid className={s.wrapper} rowGap={40}>
      <SmsCampaignsPageHeader campaignGuid={campaignGuid} name={state?.name} />
      <SmsCampaignsStats filters={filter} campaignGuid={campaignGuid} />
      <SmsCampaignsTableFilters
        data={filter}
        updateFilter={updateFilter}
        resetFilter={resetFilter}
        count={count}
      />
      <SmsCampaignsTable
        filters={filter}
        updateFilter={updateFilter}
        campaignGuid={campaignGuid}
      />
    </BaseGrid>
  );
};

export default SmsCampaignPage;
